import { render, staticRenderFns } from "./BankInfoTab1.vue?vue&type=template&id=7b7df254&scoped=true"
import script from "./BankInfoTab1.vue?vue&type=script&lang=js"
export * from "./BankInfoTab1.vue?vue&type=script&lang=js"
import style0 from "./BankInfoTab1.vue?vue&type=style&index=0&id=7b7df254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7df254",
  null
  
)

export default component.exports